import { type FC } from "react";

import { Tag } from "@snapchat/snap-design-system";
import { clsx } from "clsx";
import { addDays, isWithinInterval } from "date-fns";

import { newTagClassName } from "./NewTag.styles";
import { NewTagText } from "./messages.generated";

interface NewTagProps {
    startDate?: Date;
    visibilityDurationDays?: number;
    className?: string;
}

export const NewTag: FC<NewTagProps> = ({ startDate, visibilityDurationDays = 30, className }) => {
    const classes = clsx(newTagClassName, className);

    if (!startDate) {
        return (
            <Tag size="small" className={classes}>
                <NewTagText />
            </Tag>
        );
    }

    // Check if we're within the visibility window
    const shouldShowTag = isWithinInterval(new Date(), {
        start: startDate,
        end: addDays(startDate, visibilityDurationDays),
    });

    if (!shouldShowTag) {
        return null;
    }

    return (
        <Tag size="small" className={classes}>
            <NewTagText />
        </Tag>
    );
};
